<template>
  <v-container fluid class="pa-0">

    <v-row v-if="PARENT_COM_IDX == null || PARENT_COM_IDX == undefined || PARENT_COM_IDX.length == 0"
      dense no-gutters align="center"
      style="height:48px;background:#f6f6f6;width:100%;color:#212121; border-style:solid; border-width:0px 0px 2px 0px;border-color:#e9e9e9">
      <a @click="runLogin">
        <template v-if="this.$hostname == 'admin.mnccom-reg.com'">
          <v-avatar class="ml-5" :tile="true" width="170" height="24" >
            <img :src="require('@/assets/mnclogo.png')" alt="logo">
          </v-avatar>
        </template>
        <template v-else-if="this.$hostname == 'admin.pictcloud.com'">
          <v-avatar class="ml-5" :tile="true" width="170" height="24" >
            <img :src="require('@/assets/pictlogo.png')" alt="logo">
          </v-avatar>
        </template>
        <template v-else>
          <v-avatar class="ml-5" :tile="true" width="170" height="24" >
            <img :src="require('@/assets/logo.png')" alt="logo">
          </v-avatar>
        </template>
      </a>
      <v-spacer/>
      <v-select v-if="$uselan" 
        style="widht:100px;max-width:100px;font-size:12px;background:#f6f6f6"
        outlined dense hide-details color="#e9e9e9"
        v-model="$i18n.locale" :items="$lanlist" item-text="name" item-value="value"
        @change="changelan"
        />
    </v-row>

    <v-row align="center" justify="center" class="ma-10">
      <v-col class="join_round pl-10 pr-10" cols="12" md="5" xs="12" sm="12">

      <v-row dense no-gutters align="center" justify="center" class="mt-3 mb-10">
        <template v-if="this.$hostname == 'admin.mnccom-reg.com'">
        </template>
        <template v-else-if="this.$hostname == 'admin.pictcloud.com'">
        </template>
        <template v-else>
          <img width="160" height="20" :src="require('@/assets/logo.png')" alt="logo">
        </template>
        <label style="color:#000000;font-size:20px;font-weight: bold">&nbsp;{{$t('join_text')}}</label>
      </v-row>

      <v-row dense  align="start" justify="center">
        <v-col cols="3">
          <label>{{$t('join_id')}}</label>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="ACCNT"
            dense single-line clearable  
            maxlength="20" counter
            :placeholder="$t('join_id_holder')"
            outlined height="43"
            color="red"
            :hint="$t('join_id_hint')"
            :rules="[value => !this.pattern.test(value) || $t('join_notemail_rule'), value => !value || !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(value) || $t('join_eng_rule')]"
            />
        </v-col>
        <v-col cols="3" align="center">
          <v-btn style="width:94%" class="search_btn_freesize" 
            elevation="0" outlined large @click="checkId">{{$t('join_id_check')}}</v-btn>
        </v-col>
      </v-row>
      <v-row dense  justify="center">
        <v-col cols="3">
          <label>{{$t('join_pw')}}</label><label style="color:red">*</label>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="PW1"
            dense single-line clearable
            maxlength="30" counter 
            :placeholder="$t('join_pw_holder')"
            :hint="$t('join_pw_hint')"
            outlined height="43"
            color="red"
            type="password"
            />
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <v-col cols="3">
          <label>{{$t('join_pw2')}}</label><label style="color:red">*</label>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="PW2"
            maxlength="30" counter
            dense single-line clearable
            :placeholder="$t('join_pw_holder2')"
            :hint="$t('join_pw_hint')"
            outlined height="43"
            color="red"
            type="password"
            />
        </v-col>
      </v-row>
      <v-row dense  align="center" justify="center">
        <v-col cols="3">
          <label>{{$t('join_comkor')}}</label><label style="color:red">*</label>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="KORNAME"
            dense single-line clearable
            :placeholder="$t('join_comkor_holder')"
            outlined height="43"
            color="red"
            hide-details
            />
        </v-col>
      </v-row>

      <v-row dense  align="center" justify="center" v-if="this.$i18n.locale == 'ko'">
        <v-col cols="3">
          <label>{{$t('join_comeng')}}</label><label style="color:red">*</label>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="ENGNAME"
            dense single-line clearable
            :placeholder="$t('join_comeng_holder')"
            outlined height="43"
            color="red"
            hide-details
            />
        </v-col>
      </v-row>
      <v-row dense  align="center" justify="center">
        <v-col cols="3">
          <label>{{$t('join_ceo')}}</label><label style="color:red">*</label>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="CEONAME"
            dense single-line clearable
            :placeholder="$t('join_ceo_holder')"
            outlined height="43"
            color="red"
            hide-details
            />
        </v-col>
      </v-row>
      <v-row dense  justify="center">
        <v-col cols="3">
          <label>{{$t('join_number')}}</label><label style="color:red">*</label>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="TEL"
            counter maxlength="30"
            dense single-line clearable
            :placeholder="$t('join_number_holder')"
            outlined height="43"
            color="red"
            :rules="[value => !value || !/[^0-9+-]/.test(value) || $t('join_phone_rule')]"
            />
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <v-col cols="3">
          <label>{{$t('join_email')}}</label><label style="color:red">*</label>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="EMAIL"
            maxlength="30" counter
            dense single-line clearable
            :placeholder="$t('join_email_holder')"
            outlined height="43"
            color="red"
            />
        </v-col>
      </v-row>
      <v-row dense  justify="center">
        <v-col cols="3">
          <label>{{$t('join_mobile')}}</label><label style="color:red">*</label>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="MOBILE"
            counter maxlength="20"
            dense single-line clearable
            :placeholder="$t('join_mobile_holder')"
            outlined height="43"
            color="red"
            :rules="[value => !value || !/[^0-9-]/.test(value) || $t('join_mobile_rule')]"
            />
        </v-col>
      </v-row>

      <v-row dense  align="center" justify="center">
        <v-col cols="3">
          <label>{{$t('join_addr1')}}</label><label style="color:red">*</label>
        </v-col>
        <v-col :cols="this.$i18n.locale == 'ko' ? 6 : 9">
          <v-text-field
            v-model="ADDR1"
            dense single-line clearable :disabled="this.$i18n.locale == 'ko' ? true : false"
            :placeholder="$t('join_addr1_holder')"
            outlined height="43"
            color="red"
            hide-details
            />
        </v-col>
        <v-col cols="3" align="center" v-if="this.$i18n.locale == 'ko'">
          <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="postcode">{{$t('join_addr_btn')}}</v-btn>
        </v-col>
      </v-row>

      <v-row dense  align="center" justify="center">
        <v-col cols="3">
          <label>{{$t('join_addr2')}}</label><label style="color:red">*</label>
        </v-col>
        <v-col cols="9">
          <v-text-field
            counter="100" color="red"
            v-model="ADDR2"
            dense single-line clearable
            :placeholder="$t('join_addr2_holder')"
            outlined height="43"
            hide-details
            :rules="[ v => ( v != null && v.length <= 100) || $t('join_addr2_rules') ]"
            />
        </v-col>
      </v-row>


      <v-row dense justify="center">
        <v-col cols="3">
          <label>{{$t('join_comnumber')}}</label><label style="color:red">*</label>
        </v-col>
        <v-col cols="6">
          <v-text-field
            counter maxlength="20"
            v-model="REGNUMBER"
            dense single-line clearable
            :placeholder="$t('join_comnumber_holder')"
            outlined height="43"
            color="red"
            :rules="[value => !value || !/[^0-9-]/.test(value) || $t('join_serial_rule')]"
            />
        </v-col>
        <v-col cols="3" align="center">
          <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="checkRegNumber">{{ $t('join_id_check') }}</v-btn>
        </v-col>
      </v-row>

      <v-row dense  align="center" justify="center">
        <v-col cols="3">
          <label>{{$t('join_bank')}}</label><label style="color:red">*</label>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="BANKTYPE"
            dense single-line clearable
            :placeholder="$t('join_bank_holder')"
            outlined height="43"
            color="red"
            hide-details
            />
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <v-col cols="3">
          <label>{{$t('join_banknumber')}}</label><label style="color:red">*</label>
        </v-col>
        <v-col cols="9">
          <v-text-field
            counter maxlength="30"
            v-model="BANKNUMBER"
            dense single-line clearable
            :placeholder="$t('join_banknumber_holder')"
            outlined height="43"
            color="red"
            :rules="[value => !value || !/[^0-9-]/.test(value) || $t('join_serial_rule')]"
            />
        </v-col>
      </v-row>
      <v-row dense  align="center" justify="center">
        <v-col cols="3">
          <label>{{$t('join_comimg')}}</label><label style="color:red">*</label>
        </v-col>
        <v-col cols="9">
          <v-file-input 
            outlined dense height="43"
            show-size :label="$t('join_comimg_label')" hide-details
            v-model="uploadFile" @change="checkfilename1"
            accept=".png,.jpeg,.jpg"
            >
            </v-file-input>
        </v-col>
      </v-row>
      <v-row dense  align="center" justify="center">
        <v-col cols="3">
          <label>{{$t('join_bankimg')}}</label><label style="color:red">*</label>
        </v-col>
        <v-col cols="9">
          <v-file-input 
            outlined dense height="43"
            show-size :label="$t('join_bankimg_label')" hide-details
            v-model="uploadFile2" @change="checkfilename2"
            accept=".png,.jpeg,.jpg"
            >
            </v-file-input>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="6">
          <v-btn style="width:100%;color:white;font-size:16px" color="#546dec" rounded large @click="sendJoin">{{$t('join_btn')}}</v-btn>
        </v-col>
      </v-row>

    </v-col>
  </v-row>

  </v-container>
</template>

<script type="text/javascript" src="//dapi.kakao.com/v2/maps/sdk.js?appkey=82fc565ca4c226a9f8b7d9f0b9253275&libraries=services"></script>
<script>
import AWS from 'aws-sdk';  
export default {
    
    data: () => ({
      
      s3: null,   //aws

      CHECKACCNT:"",
      CHECKREGNUMBER:"",

      ACCNT:"",
      PW1:"",
      PW2:"",
      KORNAME:"",
      ENGNAME:"",
      CEONAME:"",
      TEL:"",
      EMAIL:"",
      MOBILE:"",
      ADDR1:"",
      ADDR2:"",
      REGNUMBER:"",
      BANKTYPE:"",
      BANKNUMBER:"",
      FILEPATH1:"",
      FILEPATH2:"",

      uploadFile : null,
      uploadFile2: null,

      PARENT_COM_IDX: null,

      pattern : /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

    }),

    methods: {
      
      changelan(){
        localStorage.setItem("LOCALE", this.$i18n.locale);
        //팝업창 텍스트 영문화
        if(this.$i18n.locale == 'ko'){        
          this.$alert_option.confirmButtonText = "확인";
          this.$alert_option.cancelButtonText  = "취소";        
        }else{        
          this.$alert_option.confirmButtonText = "OK";
          this.$alert_option.cancelButtonText  = "Cancel";
        }
      },

      checkfilename1(file){
        if(file != undefined && file != null){
          if(file.type == "image/png" || file.type == "image/jpeg"){
          }else{
            this.$alert(this.$t('join_checkfile1'));
            this.uploadFile = null;
          }
        }
      },

      checkfilename2(file){
        if(file != undefined && file != null){
          if(file.type == "image/png" || file.type == "image/jpeg"){
          }else{
            this.$alert(this.$t('join_checkfile2'));
            this.uploadFile2 = null;
          }
        }
      },

      checkId(){
        const accntValfirst = /^[a-z]/g;
        if(!accntValfirst.test(this.ACCNT)){
          this.$alert(this.$t('join_checkid'));
          return;
        }
        const accntvalidation = /^[a-z]+[a-z0-9]{3,29}$/g;
        if(!accntvalidation.test(this.ACCNT)){
          this.$alert(this.$t('join_checkid2'));
          return;
        }
        this.$http.post(this.$host+'/ime/CheckAccnt',{
              ACCNT:this.ACCNT
        })
        .then((result)=>{
          if(result.data.resultCode == 0){
              if(result.data.cnt == 0){
                //통과
                this.$alert(this.$t('join_checkid_pass'));    
                this.CHECKACCNT = this.ACCNT;
              }else{
                //실패
                this.$alert(this.$t('join_checkid_fail'));
                this.CHECKACCNT = "";
              }
          }else{
            this.$alert(this.$t('join_checkid_error'));
          }
        })
        .catch((error)=>{
          this.$alert(this.$t('join_checkid_error'));
        });
      },

      checkRegNumber(){

        const numberVal = /[^0-9-]/g;
        if(this.REGNUMBER  == undefined || this.REGNUMBER.length < 1 || this.REGNUMBER.length > 20){
          this.$alert(this.$t('join_regnum_check1'));
          return;
        } 
        if(numberVal.test(this.REGNUMBER)){
          this.$alert(this.$t('join_regnum_check2'));
        }

        //사업자등록번호 중복 확인
        this.$http.post(this.$host+'/ime/CheckRegNumber',{
              REGNUMBER:this.REGNUMBER
        })
        .then((result)=>{
          if(result.data.resultCode == 0){
              if(result.data.cnt == 0){
                //통과
                this.$alert(this.$t('join_regnum_pass'));    
                this.CHECKREGNUMBER = this.REGNUMBER;
              }else{
                //실패
                this.$alert(this.$t('join_regnum_fail'));
                this.CHECKREGNUMBER = "";
              }
          }else{
            this.$alert(this.$t('join_checkid_error'));
          }
        })
        .catch((error)=>{
          this.$alert(this.$t('join_checkid_error'));
        });        
      },

      runLogin(){

        this.$router.push("/Login");

      },

      initpage(){
      },      

      //회원가입 신청하기
      async sendJoin(){


        //첫글짜는 무조건 알파벳 
        const accntValfirst = /^[a-z]/g;
        if(!accntValfirst.test(this.ACCNT)){
          this.$alert(this.$t('join_sendjoin_accnt1'));
          return;
        }
        const accntvalidation = /^[a-z]+[a-z0-9]{3,29}$/g;
        if(!accntvalidation.test(this.ACCNT)){
          this.$alert(this.$t('join_sendjoin_accnt2'));
          return;
        }

        if(this.CHECKACCNT.length < 1 || this.ACCNT != this.CHECKACCNT){
          this.$alert(this.$t('join_sendjoin_accnt3'));
          return;
        }

        const passVal = /^[a-zA-Z0-9!@#$%^&*()]{7,29}/;
        if(this.PW1  == undefined || this.PW1.length < 1 || this.PW1.length > 30){
          this.$alert(this.$t('join_sendjoin_pw1'));
          return;
        } 
        if(!passVal.test(this.PW1)){
          this.$alert(this.$t('join_sendjoin_pw2'));
          return;
        } 
        if(this.PW2  == undefined || this.PW2.length < 1 || this.PW2.length > 30){
          this.$alert(this.$t('join_sendjoin_pw3'));
          return;
        } 
        if(!passVal.test(this.PW2)){
          this.$alert(this.$t('join_sendjoin_pw4'));
          return;
        } 
        if(this.PW1 != this.PW2){
          this.$alert(this.$t('join_sendjoin_pw5'));
          return;
        }


        if(this.KORNAME  == undefined || this.KORNAME.length < 1){
          this.$alert(this.$t('join_sendjoin_kor'));
          return;
        } 

        if(this.$i18n.locale == 'en'){
          //영문처리
          this.ENGNAME = this.KORNAME;
        }

        if(this.ENGNAME  == undefined || this.ENGNAME.length < 1){
          this.$alert(this.$t('join_sendjoin_eng'));
          return;
        } 
        if(this.CEONAME  == undefined || this.CEONAME.length < 1){
          this.$alert(this.$t('join_sendjoin_ceo'));
          return;
        } 

        const telVal = /[^0-9+-]/g;
        if(this.TEL  == undefined || this.TEL.length < 5 || this.TEL.length > 20){
          this.$alert(this.$t('join_sendjoin_tel1'));
          return;
        } 
        if(telVal.test(this.TEL)){
          this.$alert(this.$t('join_sendjoin_tel2'));
          return;
        } 
        
        
        //var emailVal = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
        var emailVal = /^[0-9a-zA-Z][-_.0-9a-zA-Z]*@[0-9a-zA-Z][-_.0-9a-zA-Z]*(\.[a-zA-Z]{2,})+$/i;
        if(this.EMAIL  == undefined || this.EMAIL.length < 1 || this.EMAIL.length > 30){
          this.$alert(this.$t('join_sendjoin_email1'));
          return;
        } 
        if(!emailVal.test(this.EMAIL)){
          this.$alert(this.$t('join_sendjoin_email2'));
          return;
        } 

        
        if(this.MOBILE  == undefined || this.MOBILE.length < 1){
          this.$alert(this.$t('join_sendjoin_mobile1'));
          return;
        } 
        const mobileVal1 = /[^0-9-]/g;
        if(mobileVal1.test(this.MOBILE)){
          this.$alert(this.$t('join_sendjoin_mobile2'));
          return;
        } 
        var mobileVal = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
        if(!mobileVal.test(this.MOBILE)){
          this.$alert(this.$t('join_sendjoin_mobile3'));
          return;
        } 
        


        if(this.ADDR1  == undefined || this.ADDR1.length < 1){
          this.$alert(this.$t('join_sendjoin_addr1'));
          return;
        } 
        if(this.ADDR2  == undefined || this.ADDR2.length < 1  || this.ADDR2.length > 50){
          this.$alert(this.$t('join_sendjoin_addr2'));
          return;
        } 

        const numberVal = /[^0-9-]/g;
        if(this.REGNUMBER  == undefined || this.REGNUMBER.length < 1 || this.REGNUMBER.length > 20){
          this.$alert(this.$t('join_sendjoin_regnum1'));
          return;
        } 
        if(numberVal.test(this.REGNUMBER)){
          this.$alert(this.$t('join_sendjoin_regnum2'));
        }
        if(this.CHECKREGNUMBER.length < 1 || this.REGNUMBER != this.CHECKREGNUMBER){
          this.$alert(this.$t('join_sendjoin_regnum3'));
          return;
        }

        if(this.BANKTYPE  == undefined || this.BANKTYPE.length < 1){
          this.$alert(this.$t('join_sendjoin_bank'));
          return;
        } 

        if(this.BANKNUMBER  == undefined || this.BANKNUMBER.length < 1 || this.BANKNUMBER.length > 30){
          this.$alert(this.$t('join_sendjoin_banknum1'));
          return;
        } 
        if(numberVal.test(this.BANKNUMBER)){
          this.$alert(this.$t('join_sendjoin_banknum2'));
          return;
        }

        if(this.uploadFile == null || this.uploadFile == undefined){
          this.$alert(this.$t('join_sendjoin_comimg'));
          return;
        }
        if(this.uploadFile2 == null || this.uploadFile2 == undefined){
          this.$alert(this.$t('join_sendjoin_bankimg'));
          return;
        }

        // s3에 파일 업로드 - company 폴더에 이미지를 올린다.
        var albumPhotosKey = encodeURIComponent("company") + "/";

        //사업자 등록증 파일
        var extens    = this.uploadFile.name.split(".");
        let extension = extens[extens.length-1];
        var filename = Date.now().toString()+"_breg."+extension;
        var photoKey = albumPhotosKey + filename;   

        const stored = await this.$s3.upload({
                                              Bucket: "blueorigin-mice-image",
                                              Key: photoKey,
                                              Body: this.uploadFile,
                                              ACL: "public-read"
                                            }).promise();
        
        this.FILEPATH1 = stored.Location;
        

        //통장사본 파일
        var extens2    = this.uploadFile2.name.split(".");
        let extension2 = extens2[extens2.length-1];
        var filename2 = Date.now().toString()+"_bank."+extension2;
        var photoKey2 = albumPhotosKey + filename2;   

        const stored2 = await this.$s3.upload({
                                              Bucket: "blueorigin-mice-image",
                                              Key: photoKey2,
                                              Body: this.uploadFile2,
                                              ACL: "public-read"
                                            }).promise();
        
        this.FILEPATH2 = stored2.Location;
        
        

        //신규
        
        this.$http.post(this.$host+'/ime/JoinInsert',{
              ADMIN_IDX: 1
            , ACCNT: escape(this.ACCNT)
            , PW: this.PW1
            , NAME: escape(this.KORNAME)
            , ENAME: escape(this.ENGNAME)
            , CEONAME: escape(this.CEONAME)
            , TEL: escape(this.TEL)
            , EMAIL: escape(this.EMAIL)
            , MOBILE: escape(this.MOBILE)
            , ADDR1: escape(this.ADDR1)
            , ADDR2: escape(this.ADDR2)
            , REGNUMBER: escape(this.REGNUMBER)
            , BANKTYPE: escape(this.BANKTYPE)
            , BANKNUMBER: escape(this.BANKNUMBER)
            , FILEPATH1: this.FILEPATH1
            , FILEPATH2: this.FILEPATH2
            , PARENT_IDX: this.PARENT_COM_IDX == null || this.PARENT_COM_IDX == undefined ? null : this.PARENT_COM_IDX
            , LAN_CODE:this.$i18n.locale
        })
        .then((result)=>{
          if(result.data.resultCode == 0){
              this.$alert(this.$t('join_join_pass')).then(()=>{
                this.$router.push("/Login");
              });
          }else{
            this.$alert(this.$t('join_join_fail'));
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.$alert(this.$t('join_join_fail'));
        });

      },


      postcodetoAddr(addr){
        this.ADDR1 = addr;
      },

      //지도
      postcode(){

        //콜백에서 못찾아서 콘스트로 미리 빼둔다.
        const callback_addrfunction     = this.postcodetoAddr;

        new daum.Postcode({
            oncomplete: function(data) {
                var addr = data.address; // 최종 주소 변수
                if(data.userSelectedType == "J"){
                  //지번
                  addr = data.jibunAddress; 
                }
                //주소 정보를 해당 필드에 넣는다.
                callback_addrfunction(addr);
            }
        }).open();

      },

    },

    mounted(){
      this.PARENT_COM_IDX = this.$route.query.PARENT_COM_IDX;
      this.initpage();
    },


    created(){
      //this.$hostname = window.location.hostname;
    }


}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

  .join_round{
    background-color: white !important;
    border-radius: 20px !important; 
    border-color:#4e6ef7 !important; 
    border-style:solid !important; 
    border-width:1px 1px 1px 1px !important;
  }

</style>